export const createLinkedAbortController = (
  externalSignal?: AbortSignal,
): AbortController => {
  const controller = new AbortController()

  if (externalSignal === undefined) return controller

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onExternalAbort = (reason?: any): void => controller.abort(reason)

  if (externalSignal.aborted) {
    onExternalAbort(externalSignal.reason)
    return controller
  }

  externalSignal.addEventListener('abort', onExternalAbort, { once: true })
  return controller
}
